import Navbar from "./Header";
import "../CSS/Contact.css";
import Footer from "./Footer";
function Contact() {
  return (
    <div className="contact">
      <Navbar />
      <div className="contact-container">
        <div className="text">
          <h3>Contact me</h3>
          <h4>for Requests and inquiries</h4>
          <p>" Please don't hesitate to contact me on "</p>
          <a href="mailto:ahmed.s.elabher@gmail.com" class="link">
            ahmed.s.elabher@gmail.com
          </a>
        </div>
      </div>
    </div>
  );
}
export default Contact;
